import React, { useState, Fragment, useCallback, useEffect } from "react";
import { format } from "date-fns";
import { jsPDF } from "jspdf";
import ReactDOM from "react-dom";
import PageHead from "../../components/pageHead";
import SearchFilter from "../../components/searchFilter";
import Button from "../../components/button";
import AddIcon from "../../icons/addIcon";
import InvoiceIcon from "../../icons/invoiceIcon";
import EditIcon from "../../icons/editIcon";
import TrashIcon from "../../icons/trashIcon";
import Table from "../../components/table";
import AddServiceModal from "../../components/addServiceModal";
import PrintIcon from "../../icons/printIcon";
import PDFDownloadIcon from "../../icons/pdfDownloadIcon";
import CloseIcon from "../../icons/closeIcon";
import ServiceCard from "../../components/serviceCard";
import DeleteCarModal from "../../components/deleteModal";
import useMediaQuery from "../../hooks/useMediaQuery";
import TutorialServiceImage from "../../assets/images/tutorialService.png";
import TutorialHistoryImage from "../../assets/images/tutorialHistory.png";
// import { checkScrollDirection } from "../../utils/menuNav";
import { useAxiosPrivate } from "../../hooks/useAxiosPrivate";
import Pagination from "../../components/pagination";
import MobileNav from "../../components/mobileNav";
import CardSkeleton from "../../components/cardSkeleton";
import NoData from "../../components/noData";
import styles from "./style.module.css";
import { Document, Page, pdfjs } from "react-pdf";
import "react-pdf/dist/esm/Page/AnnotationLayer.css";
import "react-pdf/dist/esm/Page/TextLayer.css";
import stylesTable from "../../components/table/style.module.css";

// Add PDF.js worker configuration
pdfjs.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@3.11.174/build/pdf.worker.min.js`;

const ServiceHistory = () => {
  const isMobile = useMediaQuery("(max-width: 768px)");
  const envUrl = process.env.REACT_APP_API_BASE_URL || "";
  const axiosPrivate = useAxiosPrivate();
  const [openDialog, setOpenDialog] = useState(false);
  const [isScrolling] = useState(false);
  const [mainColumns, setMainColumns] = useState({
    columns: [
      {
        name: "date",
        title: "Date",
        width: 150,
        sorting: true,
        direction: "",
      },
      {
        name: "mileage",
        title: "Mileage",
        width: 110,
        sorting: true,
        direction: "",
      },
      {
        name: "consumable",
        title: "Category",
        width: 200,
        sorting: true,
        direction: "",
      },
      {
        name: "description",
        title: "Description",
        width: 350,
        sorting: true,
        direction: "",
      },
      {
        name: "source",
        title: "Source",
        width: 200,
        sorting: true,
        direction: "",
      },
      {
        name: "cost",
        title: "Cost",
        width: 100,
        sorting: true,
        direction: "",
      },
      {
        name: "attachment",
        title: "Attachment",
        width: 115,
        sorting: false,
        direction: "",
      },
      {
        name: "action",
        title: "Action",
        width: 130,
        sorting: false,
        direction: "",
      },
    ],
  });
  const [rowData, setRowData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selectedPage, setSelectedPage] = useState(1);
  const [limitData] = useState(10);
  const [apiParams] = useState({ limit: limitData });
  const [totalData, setTotalData] = useState(0);
  const [serviceData, setServiceData] = useState({});
  const [modalTitle, setModalTitle] = useState("Add New Service");
  const [buttonTitle, setButtonTitle] = useState("Add");
  const [openDeleteServiceModal, setOpenDeleteServiceModal] = useState(false);
  const [downloadLoading, setDownloadLoading] = useState(false);
  const [pdfData, setPdfData] = useState(null);
  const [serviceDate, setServiceDate] = useState(null);

  const handleSorting = (name, index) => {
    let prm = apiParams;
    let tempCol = mainColumns.columns;
    if (tempCol[index].direction === "") {
      tempCol.map((column) =>
        column.name === name
          ? (column.direction = "ASC")
          : (column.direction = "")
      );
      prm.sort_by = name;
      prm.order = 1;
      prm.page = 1;
    } else if (tempCol[index].direction === "ASC") {
      tempCol.map((column) =>
        column.name === name
          ? (column.direction = "DSC")
          : (column.direction = "")
      );
      prm.sort_by = name;
      prm.order = -1;
      prm.page = 1;
    } else if (tempCol[index].direction === "DSC") {
      tempCol.map((column) => (column.direction = ""));
      prm.page = 1;
      delete prm.sort_by;
      delete prm.order;
    }
    setMainColumns({ columns: tempCol });
    setSelectedPage(1);
    fetchServiceHistory(apiParams);
  };

  const handlePaginate = (value) => {
    let prm = apiParams;
    prm.page = value;
    setSelectedPage(value);
    setLoading(true);
    fetchServiceHistory(prm);
  };

  const handleOpenDialog = () => {
    setOpenDialog(true);
    setModalTitle("Add New Service");
    setButtonTitle("Add");
    setServiceData({});
  };

  const handleOpenEditDialog = (service) => {
    let date = format(new Date(service.date.replace("Z", "")), "MM-dd-yyyy");
    let file = service?.attachments[0];
    setServiceData({
      date: date,
      mileage: service.mileage,
      category: JSON.stringify({
        title: service?.consumable?.name,
        value: service?.consumable?._id,
      }),
      description: service.description,
      source: service.source,
      cost: service.cost,
      files: `${envUrl}/${file}`,
      _id: service._id,
    });
    setOpenDialog(true);
    setModalTitle("Edit Service");
    setButtonTitle("Save");
  };

  const handleCloseDialog = (changePage = false) => {
    setOpenDialog(false);
    if (changePage) {
      fetchServiceHistory(apiParams);
    }
  };

  const handleScroll = (e) => {
    // const scrollDirection = checkScrollDirection(e);
    // setIsScrolling(scrollDirection);
  };

  const fetchServiceHistory = useCallback(async (params) => {
    setLoading(true);
    try {
      let urlParams = "";
      if (params) {
        Object.keys(params).forEach(function (key, index) {
          urlParams += (index === 0 ? "?" : "&") + key + "=" + params[key];
        });
      }
      let url = `services${urlParams}`;
      let options = {
        method: "GET",
        url,
      };
      await axiosPrivate(options)
        .then((response) => {
          if (response.data.status === 1) {
            setRowData(response.data.services);
            setTotalData(response.data.total);
            setLoading(false);
          } else {
            setRowData([]);
            setTotalData(0);
            setLoading(false);
          }
        })
        .catch((err) => {
          if (err.response) {
            setLoading(false);
            // console.error('err.res', err.response.data);
          }
        });
    } catch (error) {
      setLoading(false);
      // console.error('error', error);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const downloadAttachment = useCallback(async (id, date) => {
    try {
      setDownloadLoading(true);
      setPdfData(null);
      setServiceDate(date);
      const pdfOptions = {
        overrides: {
          pdf: {},
          canvas: {},
        },
        page: {
          format: "a4",
          orientation: "portrait",
          margin: 10,
        },
        resolution: 4,
        canvas: {
          mimeType: "image/jpeg",
          qualityRatio: 1,
        },
      };

      let url = `services/${id}/attachments`;
      let options = {
        method: "GET",
        url,
        responseType: "blob",
      };
      await axiosPrivate(options)
        .then(async (response) => {
          // Convert blob to data URL
          const reader = new FileReader();
          reader.readAsDataURL(response.data);
          reader.onloadend = function () {
            const dataUrl = reader.result;
            const doc = new jsPDF({
              format: pdfOptions.page.format,
              orientation: pdfOptions.page.orientation,
              compressPdf: false,
            });

            // Calculate center position for the image
            const pdfWidth = doc.internal.pageSize.getWidth();
            const imgWidth = pdfWidth;
            const imgHeight = 0; // Set to 0 to maintain aspect ratio when using addImage
            const x = (pdfWidth - imgWidth) / 2;

            doc.addImage(dataUrl, "PNG", x, 10, imgWidth, imgHeight, "NONE");
            doc.setDisplayMode("fullwidth");
            doc.setProperties({
              title: "Attachment",
            });

            // Get the PDF as a blob instead of bloburl
            const pdfBlob = doc.output("blob");
            setPdfData(pdfBlob);
            setDownloadLoading(false);
          };
        }) // Clean up the URL object
        .catch((err) => {
          if (err.response) {
            // console.error('err.res', err.response.data);
          }
        });
    } catch (error) {
      // console.error('error', error);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handlePrint = () => {
    if (pdfData) {
      const url = URL.createObjectURL(pdfData);
      document.querySelectorAll(".print_iframe_hide").forEach((item) => {
        item.remove();
      });
      const iframe = document.createElement("iframe");
      iframe.classList.add("print_iframe_hide");
      iframe.style.display = "none";
      iframe.style.border = "none";
      document.body.appendChild(iframe);

      // Add print styles
      const style = document.createElement("style");
      style.textContent = `
        @media print {
          body > *:not(.print_iframe_hide) {
            display: none !important;
          }
          .print_iframe_hide {
            position: static !important;
            width: 100% !important;
            height: 100% !important;
            margin: 0 !important;
            padding: 0 !important;
            overflow: hidden !important;
            display: block !important;
          }
          @page {
            margin: 0;
            size: auto;
          }
        }
      `;
      document.head.appendChild(style);

      iframe.onload = () => {
        try {
          iframe.contentWindow.print();
        } catch (error) {
          console.error("Print failed:", error);
        }
      };

      iframe.src = url;
    }
  };

  const handleDownload = () => {
    if (pdfData) {
      const url = URL.createObjectURL(pdfData);
      const link = document.createElement("a");
      link.href = url;
      link.download = `Service_Attachment_${serviceDate}.pdf`;
      link.click();
      URL.revokeObjectURL(url);
    }
  };

  const handleClosePDF = () => {
    setPdfData(null);
    let iframe = document.querySelectorAll(".print_iframe_hide");
    if (iframe) {
      iframe.forEach((item) => {
        item.remove();
      });
    }
    setServiceDate(null);
  };

  const handleSearch = useCallback(
    (value) => {
      setLoading(true);
      let prm = apiParams;
      setSelectedPage(1);
      prm.page = 1;
      if (value.length > 0) {
        prm.s = value;
      } else {
        delete prm.s;
      }
      fetchServiceHistory(prm);
    },
    [apiParams, fetchServiceHistory]
  );

  const handleOpenDeleteServiceModal = (service) => {
    setOpenDeleteServiceModal(true);
    setServiceData(service);
  };

  const handleCloseDeleteServiceModal = () => {
    setOpenDeleteServiceModal(false);
  };

  const handleDeleteService = async () => {
    const response = await axiosPrivate.delete(`/services/${serviceData._id}`);
    if (response.data.status === 1) {
      let prm = apiParams;
      prm.page = 1;
      setSelectedPage(1);
      fetchServiceHistory(prm);
      handleCloseDeleteServiceModal();
    }
  };

  function generateRows(tempArray) {
    const tempRowArray = [];
    if (tempArray) {
      tempArray.map((item) =>
        tempRowArray.push({
          date: (
            <div className={stylesTable.table_cell_text}>
              {format(new Date(item.date.replace("Z", "")), "MMMM dd, yyyy")}
            </div>
          ),
          mileage: (
            <div className={stylesTable.table_cell_text}>{item.mileage}</div>
          ),
          consumable: (
            <div className={stylesTable.table_cell_text}>
              {item?.consumable?.name || "N/A - Non Consumable"}
            </div>
          ),
          description: (
            <div className={stylesTable.table_cell_text}>
              {item.description}
            </div>
          ),
          source: (
            <div className={stylesTable.table_cell_text}>{item.source}</div>
          ),
          cost: (
            <div className={stylesTable.table_cell_text}>
              {item.cost ? `$${item.cost}` : ""}
            </div>
          ),
          attachment: (
            <div className={stylesTable.table_cell_icon_link}>
              {item.attachments.map((attachment, index) => (
                <div
                  key={index}
                  onClick={() =>
                    downloadAttachment(
                      item._id,
                      format(
                        new Date(item.date.replace("Z", "")),
                        "dd-MMM-yyyy"
                      )
                    )
                  }
                  className={stylesTable.table_cell_icon}
                >
                  <InvoiceIcon />
                </div>
              ))}
            </div>
          ),
          action: (
            <div className={stylesTable.table_action}>
              <button type="button" onClick={() => handleOpenEditDialog(item)}>
                <EditIcon />
              </button>
              <button
                type="button"
                onClick={() => handleOpenDeleteServiceModal(item)}
              >
                <TrashIcon />
              </button>
            </div>
          ),
        })
      );
    }
    return tempRowArray;
  }

  useEffect(() => {
    fetchServiceHistory(apiParams);
  }, [fetchServiceHistory, apiParams]);

  return (
    <Fragment>
      <PageHead
        logo={isMobile}
        title="Service History"
        tutorialContent={
          <Fragment>
            <p>
              This section stores all past maintenance records. At the top, use
              the <strong>search bar</strong> to find specific entries, or
              scroll through and sort by column.
            </p>
            <ul>
              <li>
                To <strong>edit</strong> an entry, click the{" "}
                <strong>Edit icon</strong>.
              </li>
              <li>
                To <strong>delete</strong> an entry, click the{" "}
                <strong>Trash icon</strong>.
              </li>
              <li>
                To <strong>add a new service entry</strong>, click{" "}
                <strong>Add New Service</strong> at the top.
              </li>
            </ul>
            <img src={TutorialHistoryImage} alt={"Service History Page"} />
            <hr />
            <h4>Entering New Service</h4>
            <p>
              On this page, log the <strong>maintenance and repairs</strong>{" "}
              performed on your vehicle. This includes both consumable items and
              long-term services such as repairs and upgrades. Only consumable
              items will appear on your <strong>Snapshot Page</strong>, while
              all other service records will be stored in{" "}
              <strong>Service History</strong>.
            </p>
            <img src={TutorialServiceImage} alt={"Entering New Service"} />
            <p>When entering a service item:</p>
            <ol>
              <li>
                Select the <strong>Consumables category</strong> if applicable
                (e.g., Oil Change, Brake pads, etc.). If you want to add a
                custom category, you can add it from the Utilities menu {" > "}
                Set Up Consumables page.
              </li>
              <li>
                For non-consumables (e.g., A/C repair), select{" "}
                <strong>N/A - Not Consumable</strong>.
              </li>
              <li>
                Enter the{" "}
                <strong> date, description, provider, and cost</strong>.
              </li>
              <li>
                Use the <strong>comments field</strong> for part numbers,
                installation notes, or supplier contact info.
              </li>
              <li>Upload files such as receipts or photos for reference.</li>
            </ol>
            <p>
              <strong>Tip:</strong> For the initial setup, enter only the{" "}
              <strong>most recent</strong> consumables service. You can add more
              records later to build a complete maintenance history – but keep
              in mind, DashBook can’t provide an accurate status on any item
              until the last service is logged.
            </p>
          </Fragment>
        }
      />
      {downloadLoading &&
        ReactDOM.createPortal(
          <div className={styles.body_print_loader}>
            <div className={styles.body_print_loader_inner} />
          </div>,
          document.body
        )}
      {pdfData &&
        ReactDOM.createPortal(
          <div className={styles.pdf_viewer}>
            <div className={styles.pdf_viewer_wrapper}>
              <div className={styles.pdf_actions}>
                <button
                  className={styles.pdf_action_btn}
                  type="button"
                  onClick={handlePrint}
                  title="Print PDF"
                >
                  <PrintIcon />
                </button>
                <button
                  className={styles.pdf_action_btn}
                  type="button"
                  onClick={handleDownload}
                  title="Download PDF"
                >
                  <PDFDownloadIcon />
                </button>
                <div
                  className={styles.pdf_action_btn}
                  type="button"
                  onClick={handleClosePDF}
                  title="Close PDF"
                >
                  <CloseIcon />
                </div>
              </div>
              <Document
                file={pdfData}
                loading={
                  <div className={styles.pdf_loading}>
                    <div className={styles.pdf_loading_text}>
                      Loading PDF...
                    </div>
                  </div>
                }
                error={
                  <div className={styles.pdf_error}>Failed to load PDF.</div>
                }
                className={styles.pdf_document}
                options={{
                  cMapUrl:
                    "https://cdn.jsdelivr.net/npm/pdfjs-dist@3.11.174/cmaps/",
                  cMapPacked: true,
                  standardFontDataUrl:
                    "https://cdn.jsdelivr.net/npm/pdfjs-dist@3.11.174/standard_fonts/",
                }}
              >
                <Page
                  pageNumber={1}
                  width={Math.min(window.innerWidth * 0.8, 800)}
                  className={styles.pdf_page}
                />
              </Document>
            </div>
          </div>,
          document.body
        )}
      <div className={styles.body}>
        <div className={styles.body_head}>
          <div className={styles.body_head_inner}>
            <div className={styles.filters}>
              <SearchFilter onSearch={handleSearch} />
            </div>
            <div className={styles.add_btn}>
              <Button
                title={isMobile ? "Service" : "Add New Service"}
                buttonType="outlined"
                buttonColor="primary"
                startIcon={<AddIcon />}
                onClick={handleOpenDialog}
              />
            </div>
          </div>
        </div>
        <div className={styles.body_view} onScroll={handleScroll}>
          {isMobile ? (
            <Fragment>
              {rowData.map((item, index) => (
                <ServiceCard
                  key={index}
                  service={item}
                  handleEdit={handleOpenEditDialog}
                  handelDelete={handleOpenDeleteServiceModal}
                  handelDownload={downloadAttachment}
                />
              ))}
              {loading && <CardSkeleton />}
              {totalData === 0 && !loading && <NoData />}
            </Fragment>
          ) : (
            <Table
              rows={generateRows(rowData)}
              columns={mainColumns.columns}
              selectedPage={selectedPage}
              handlePagination={handlePaginate}
              loading={loading}
              handleSort={handleSorting}
              limitData={limitData}
              totalData={totalData}
            />
          )}
        </div>
        {isMobile && (
          <Fragment>
            {totalData > limitData && (
              <div className={styles.body_foot}>
                <Pagination
                  totalPages={totalData}
                  limitData={limitData}
                  selectedPage={selectedPage}
                  handlePagination={handlePaginate}
                />
              </div>
            )}
          </Fragment>
        )}
      </div>
      {isMobile && <MobileNav defaultActive={true} isScrolling={isScrolling} />}
      <AddServiceModal
        serviceData={serviceData}
        open={openDialog}
        onClose={handleCloseDialog}
        title={modalTitle}
        buttonTitle={buttonTitle}
      />
      <DeleteCarModal
        open={openDeleteServiceModal}
        onClose={handleCloseDeleteServiceModal}
        title="Deleting Service"
        description="Are you sure you want to delete this record? This process cannot be undone."
        onDelete={handleDeleteService}
      />
    </Fragment>
  );
};

export default ServiceHistory;
